if (!customElements.get('video-mask')) {
  customElements.define(
    'video-mask',
    class VideoMask extends window.BAO.CustomElement {
      constructor () {
        super()
      }

      connectedCallback () {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)

        this.updateEl()
      }

      setupListeners () {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })
      }

      onScroll () {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl () {
        this.isTicking = false

        this.handleScroll()
      }

      handleScroll () {
        const maskEl = this.querySelector('[data-video-mask-el="mask"]')
        const buttonEl = this.querySelector('[data-video-mask-el="button"]')
        const triggerEl = this.querySelector(
          '[data-video-mask-el="desktop-trigger"]'
        )

        const containerOffsetTop = getOffsetTop(this)

        const elementStartPoint = containerOffsetTop
        const elementEndPoint =
          elementStartPoint + this.offsetHeight - window.innerHeight * 1.5

        const amountToScale = 1
        const opacityToChange = 2

        const buttonOpacityToChange = 1

        if (this.lastKnownY <= elementStartPoint) {
          maskEl.style.transform = `scale(1)`
          maskEl.style.opacity = 1

          if (buttonEl) {
            buttonEl.style.opacity = 0
          }
          if (triggerEl) {
            triggerEl.style.display = 'none'
          }

          return
        }

        if (this.lastKnownY > elementEndPoint) {
          maskEl.style.transform = `scale(${1 + amountToScale})`
          maskEl.style.opacity = 0

          if (buttonEl) {
            buttonEl.style.opacity = 1
          }
          if (triggerEl) {
            triggerEl.style.display = 'block'
          }

          return
        }

        const totalScrollAmount = elementEndPoint - elementStartPoint

        const scrollYAsAPercentageOfJourney =
          (this.lastKnownY - elementStartPoint) / totalScrollAmount

        const scaleAmount = 1 + amountToScale * scrollYAsAPercentageOfJourney
        const opacityAmount =
          opacityToChange - opacityToChange * scrollYAsAPercentageOfJourney

        const buttonOpacityAmount =
          buttonOpacityToChange * scrollYAsAPercentageOfJourney

        maskEl.style.transform = `scale(${scaleAmount})`
        maskEl.style.opacity = opacityAmount

        if (buttonEl) {
          buttonEl.style.opacity = buttonOpacityAmount
        }
      }
    }
  )
}
